const defaultTheme = require('tailwindcss/defaultTheme');

const Color = require('color');

const lighten = (clr, val) => Color(clr)
    .lighten(val)
    .hex();
const darken = (clr, val) => Color(clr)
    .darken(val)
    .hex();

const primaryColor = '#00308F';
const secondaryColor = '#493E39';
const tertiaryColor = '#F28C28';

// tailwind.config.js
module.exports = {
    darkMode: 'class',
    content: [
        './resources/**/*.{blade.php,js}',
        './workbench/**/*.{blade.php,js}',
        './cmeleon-core/resources/**/*.{blade.php,js}',
        './node_modules/@inova/cookie-consent/**/*.js',
    ],
    theme: {
        // overrides
        container: {
            screens: {
                '2xl': '1434px',
            },
        },
        fontFamily: {
            sans: ['Roboto', 'Arial', 'sans-serif'],
            heading: ['Anton', 'Roboto', 'Arial', 'sans-serif'],
        },
        boxShadow: {
            DEFAULT: '0 0 8px 0 rgba(0, 0, 0, 0.1)',
            md: '0 0 16px 0 rgba(0, 0, 0, 0.1)',
            lg: '0 0 32px 0 rgba(0, 0, 0, 0.1)',
            none: '0 0 rgba(0, 0, 0, 0.0)',
            cart: '0 1px 5px rgba(50 50 50, 0.34)',
        },
        extend: {
            // extends
            colors: {
                primary: {
                    50: '#d8e3fa',
                    300: lighten(primaryColor, 0.4),
                    400: lighten(primaryColor, 0.2),
                    500: primaryColor, // Default
                    600: darken(primaryColor, 0.1),
                    700: darken(primaryColor, 0.2),
                },
                secondary: {
                    300: lighten(secondaryColor, 0.4),
                    400: lighten(secondaryColor, 0.2),
                    500: secondaryColor, // Default
                    600: darken(secondaryColor, 0.1),
                    700: darken(secondaryColor, 0.2),
                },
                tertiary: {
                    50: lighten(tertiaryColor, 0.75),
                    300: lighten(tertiaryColor, 0.4),
                    400: lighten(tertiaryColor, 0.2),
                    500: tertiaryColor, // Default
                    600: darken(tertiaryColor, 0.1),
                    700: darken(tertiaryColor, 0.2),
                },
                gray: {
                    10: '#f7f7f7',
                    50: '#f2f2f2',
                },
            },
            spacing: {
                18: '4,5rem',
                'vhfix': 'calc(100vh + 120px)',
                'vhfixpadding': '120px',
            },
            minHeight: {
                'full': '100%',
                hero: '20rem',
                'background-image': '25rem',
                'hero-large': '30rem',
                'highlight-slide': '30rem',
                'content-video': '540px',
            },
            minWidth: {
                ...defaultTheme.spacing,
                'full': '100%',
                '2/3': '66%',
            },
            maxHeight: {
                'screen-1/9': '90vh',
            },
            maxWidth: {
                '10/12': '83.333333%',
            },
            fontSize: {
                '2xs': ['0.65rem', { lineHeight: '0.9rem' }],
                '3xs': ['0.5rem', { lineHeight: '0.75rem' }],
            },
            gridTemplateColumns: {
                '150/fr': '150px 1fr',
                '150/fr/fr': '150px 1fr 1fr',
            },
            transitionProperty: {
                size: 'max-height, max-width',
                spacing: 'margin, padding',
            },
        },
    },
    variants: {
        extend: {
            borderColor: ['active'],
        },
    },
    plugins: [],
};
